import curry from "../../lib/core/functional/curry";

import openWindow from "../../utils/openWindow";

import freeze from "./clickHandlers/freeze";
import remove from "./clickHandlers/remove";

const openPostWindow = curry((template, context) =>
    openWindow(template.replace("{POST_ID}", context.postId))
);

const menuClickHandlerMap = {
    freeze,
    remove,
    edit: openPostWindow("/r/entryeditor/{POST_ID}"),
    socialScheduling: openPostWindow("/r/entryeditor/{POST_ID}#social_scheduling"),
    socialCopy: openPostWindow("/r/entryeditor/{POST_ID}#social"),
    stats: openPostWindow("/r/entryeditor/{POST_ID}#stats"),
};

export default menuClickHandlerMap;
